/**
 *  <NumberCount
        value={value}
        min={1}
        max={10}
        interval={2}
        onChange={this.numberChange.bind(this, d)}
        onError={this.numberError}
        />
    errorCode: {
        1001: 小于最小值,
        1002: 大于最大值,
        1003: 倍数
    }
 */
const React = require('react');
const css = require('./module.scss');

const Input = require('../input');
const Prompt = require('../dialog/prompt');
let timeOut;
class NumberCount extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            min: props.min != undefined ? props.min : 1,
            max: props.max || 999999999,
            value: props.value,
            interval: props.interval || 1
        };

        this.minus = this.minus.bind(this);
        this.plus = this.plus.bind(this);
        this.valueChange = this.valueChange.bind(this);
        this.keyDown = this.keyDown.bind(this);
        this.validValue = this.validValue.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            min: nextProps.min != undefined ? nextProps.min : 1,
            max: nextProps.max || 999999999,
            value: nextProps.value,
            interval: nextProps.interval || 1
        });
    }

    minus() {
        if (this.props.disabled) {
            return false;
        }
        let diff = this.state.value - this.state.interval;
        if (diff < this.state.min) {
            this.props.onError && this.props.onError(1001);
            return false;
        }

        this.setState({
            value: diff
        });
        this.props.onChange && this.props.onChange(diff);
    }

    plus() {
        if (this.props.disabled) {
            return false;
        }
        let sum = +this.state.value + this.state.interval;
        if (sum > this.state.max) {
            this.props.onError && this.props.onError(1002);
            return false;
        }

        this.setState({
            value: sum
        });
        this.props.onChange && this.props.onChange(sum);
    }

    validValue(value) {
        if (+value == '' || !('' + value).match(/^[0-9]+$/g)) { // 处理非数字的输入
            value = this.state.min;
        } else if (value <= this.state.min) {  // 处理小于最小值的输入
            value = this.state.min;
            this.props.onError && this.props.onError(1001);
        } else if (value >= this.state.max) {  // 处理大于最大值的输入
            value = parseInt(Math.floor(this.state.max / this.state.interval) * this.state.interval, 10);
            this.props.onError && this.props.onError(1002);
        } else if ((value % this.state.interval !== 0)) {
            value = parseInt(Math.ceil(value / this.state.interval) * this.state.interval);
            this.props.onError && this.props.onError(1003);
        }

        this.setState({
            value: +value
        });
        this.props.onChange && this.props.onChange(+value);
    }

    valueChange(e) {
        let value = e.target.value;
        this.setState({
            value
        });
        if (timeOut) {
            clearTimeout(timeOut);
        }
        timeOut = setTimeout(() => {
            this.validValue(value);
        }, 500);
    }


    keyDown(e) {
        let keyCode = e.keyCode;
        if (keyCode === 38) {
            e.preventDefault();
            this.plus();
            return;
        }
        if (keyCode === 40) {
            e.preventDefault();
            this.minus();
            return;
        }
    }


    render() {
        let cls = ["fp-number-count-wrap"];
        if (this.props.className) {
            cls.push(this.props.className);
        }
        if (this.props.disabled) {
            cls.push('fp-number-count-disabled');
        }

        return <div className={cls.join(' ')}>
            <Input className="fp-number-count-input"
                value={this.state.value}
                onChange={this.valueChange}
                onKeyDown={this.keyDown}
                disabled={this.props.disabled}
            />
            <a className="fp-plus" onClick={this.plus}></a>
            <a className="fp-minus" onClick={this.minus}></a>
        </div>;
    }
}

module.exports = NumberCount;



// WEBPACK FOOTER //
// ./component/numberCount/index.js